<div *ngIf="show" 
     [class]="overlayClass"
     [class.spinner-blur]="blurBackground"
     [class.spinner-no-blur]="!blurBackground">
  
  <div [class]="contentClass">
    
    <!-- Spinner principal -->
    <div class="spinner" 
         [style.width.px]="spinnerSize"
         [style.height.px]="spinnerSize"
         [style.border-width.px]="borderWidth"
         [style.border-top-color]="color">
    </div>
    
    <!-- Texto (opcional) -->
    <p *ngIf="showText && text" class="spinner-text">
      {{ text }}
    </p>
    
  </div>
  
</div>